(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/assets/javascripts/category-page.js') >= 0) return;  svs.modules.push('/modules/lb-casino/assets/javascripts/category-page.js');
"use strict";


class CategoryPage {
  constructor() {
    var _svs$lb_casino$data, _svs$lb_casino$data2, _svs$lb_casino$data3, _svs$lb_casino$data4;
    if (svs.core.detect.formfactor.mobile()) {
      if (svs.core.detect.feature('ft-floating-swish-buttons')) {
        new svs.casino.quick_transaction.TransactionButtons();
      }
    }
    svs.components.casino.game.extendCache((_svs$lb_casino$data = svs.lb_casino.data) === null || _svs$lb_casino$data === void 0 ? void 0 : _svs$lb_casino$data.renderModel.gameList.map(game => game.game && game.game.name || game) 
    .map(gameName => svs.components.casino.data.gameCache.index[gameName])); 
    new svs.components.casino.GameList((_svs$lb_casino$data2 = svs.lb_casino.data) === null || _svs$lb_casino$data2 === void 0 ? void 0 : _svs$lb_casino$data2.renderModel.gameList, false, (_svs$lb_casino$data3 = svs.lb_casino.data) === null || _svs$lb_casino$data3 === void 0 ? void 0 : _svs$lb_casino$data3.renderModel.casinoSection, (_svs$lb_casino$data4 = svs.lb_casino.data) === null || _svs$lb_casino$data4 === void 0 ? void 0 : _svs$lb_casino$data4.renderModel.currentCategory.title);
  }
}
setGlobal('svs.lb_casino.initCategoryPage', () => new CategoryPage());

 })(window);